import { render, staticRenderFns } from "./DoughNutChartCustom.vue?vue&type=template&id=6eafaba4&scoped=true&"
import script from "./DoughNutChartCustom.vue?vue&type=script&lang=js&"
export * from "./DoughNutChartCustom.vue?vue&type=script&lang=js&"
import style0 from "./DoughNutChartCustom.vue?vue&type=style&index=0&id=6eafaba4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eafaba4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
